<template>
    <div class="chat-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 114.89 97.09" style="enable-background:new 0 0 114.89 97.09;" xml:space="preserve">

            <g>
                <path class="st0" d="M75.16,3.57H40.11c-20.38,0-37.06,16.68-37.06,37.06v0c0,20.38,16.68,37.06,37.06,37.06h21.64l27.09,16.16
                    v-18.8c13.66-5.47,23.38-18.86,23.38-34.42v0C112.22,20.25,95.54,3.57,75.16,3.57z M30.72,50.36c-4.91,0-8.88-3.98-8.88-8.88
                    s3.98-8.88,8.88-8.88s8.88,3.98,8.88,8.88S35.62,50.36,30.72,50.36z M58.25,50.36c-4.91,0-8.88-3.98-8.88-8.88s3.98-8.88,8.88-8.88
                    s8.88,3.98,8.88,8.88S63.15,50.36,58.25,50.36z M85.78,50.36c-4.91,0-8.88-3.98-8.88-8.88s3.98-8.88,8.88-8.88s8.88,3.98,8.88,8.88
                    S90.68,50.36,85.78,50.36z"/>
            </g>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }       
}
</script>

<style lang="scss" scoped>
    .st0{fill:#FFFFFF;}
</style>
